<template>
    <!-- 新增/编辑班级 -->
    <el-dialog custom-class="dialogForm" class="measDialog" :visible.sync="visible" :before-close="handleClose" :close-on-click-modal="false" width="80%" :title="title+'班级'">
        <el-scrollbar class="dialogContentScroll">
            <el-form :model="form" ref="form" :rules="rules">
                <div class="moduleTitle">基本信息</div>
                <el-form-item label="班级名称" prop="classdetails.name">
                    <el-input v-model="form.classdetails.name" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input>
                </el-form-item>
                <div class="formItem">
                    <div class="itemBox mr-30">
                        <el-form-item label="参与校区" prop="classdetails.campusname">
                            <!-- <el-select @change="getCode" v-model="schoolNames" multiple placeholder="请选择">
                                <el-option
                                v-for="item in schoolList"
                                :key="item.code"
                                :label="item.name"
                                :value="item.name">
                                </el-option>
                            </el-select> -->
                            <SelectPage :listLoading="false" key="1" @changePageGetList="changePageGetListSchool" @getSelectValue="getSelectValue" label="name" value="code" 
                            :list="schoolList" :initData="initData"  :isMultiple="true" :paginationOption="paginationOption" />
                        </el-form-item>
                    </div>
                    <div class="itemBox">
                        <el-form-item label="授课价格（元）" prop="classdetails.uprice">
                            <el-input v-model="form.classdetails.uprice" type="number" placeholder="请输入" clearable></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="formItem">
                    <div class="itemBox mr-30">
                        <el-form-item label="授课开始时间" prop="classdetails.begindate">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="form.classdetails.begindate"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="itemBox">
                        <el-form-item label="授课结束时间" prop="classdetails.enddate">
                            <el-date-picker
                                v-model="form.classdetails.enddate"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                </div>
                <div class="formItem">
                    <div class="itemBox mr-30">
                        <el-form-item label="报名截止时间" prop="classdetails.enrollenddate">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="form.classdetails.enrollenddate"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </div>
                    <!-- 占位 -->
                    <div class="itemBox">
                        <!-- <el-form-item label="报名截止时间" prop="classdetails.enrollenddate">
                            <el-date-picker
                                value-format="yyyy-MM-dd"
                                v-model="form.classdetails.enrollenddate"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item> -->
                    </div>
                </div>
                <el-form-item label="封面图片" prop="classdetails.coveratturl">
                    <div class="tips">建议尺寸 750*420px 或者 16:9，JPG、PNG 格式， 图片小于 5M。</div>
                    <div class="uploadItemBox">
                        <div class="uploadItem flex">
                            <div v-if="coveratt.length > 0" class="flex">
                                <div @click="delImg(idx)" class="imgItm" v-for="(itm,idx) in coveratt" :key="idx">
                                    <img class="coveratturl mr-10" :src="itm.coveratturl + '?v=' + now"  alt="">
                                    <div class="del">删除</div>
                                </div>
                            </div>
                            <UploadFile v-if="visible" :isRepeatedlyFile="true" ref="uploadFile1" accept=".png,.jpeg,.jpg" :show-file-list="false" :scopeType="106" :fileMaxSize="5120" @success="coveratt1UploadSuccess">
                                <div class="flex">
                                    <div class="noCoveratturl" v-if="coveratt.length < 5">
                                        <i class="el-icon-plus"></i>
                                        <div class="label">上传图片</div>
                                    </div>
                                </div>
                            </UploadFile>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="班级简介" prop="summary">
                    <el-input v-model="form.classdetails.summary" maxlength="100" show-word-limit type="textarea" placeholder="请输入课程简介"></el-input>
                </el-form-item>
                <el-form-item label="班级详情">
                    <UEditor :content="form.classdetails.content" ref="uEditor" @getUEditorContent="getUEditorContent" />
                </el-form-item>
                <div class="moduleTitle">课程信息</div>
                <el-table class="table-fixed-col" ref="multipleTable" border :data="form.courselist" style="width: 100%">
                    <el-table-column width="100" key="scope.row.name" align="center" prop="name" label="课程名称">
                        <template slot-scope="scope">
                            <!-- <el-autocomplete
                                v-model="scope.row.name"
                                :fetch-suggestions="querySearchAsync"
                                placeholder="请输入内容"
                                @select="getCourCode($event, scope.$index)"
                            ></el-autocomplete> -->
                            <SelectPage :listLoading="false" ref="SelectPage" key="2" :remoteStatus="true" @searchValue="searchValue" :filterableStatus="true" @getSelectValue="getSelectValueClass($event, scope.$index)" label="name" value="code"
                            :list="courNames" :initData="handleCourNames(scope.row)[0]" @changePageGetList="changePageGetListClass" :isMultiple="false" :paginationOption="paginationOptionCourNames" />
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" prop="" label="学分数">
                        <template slot-scope="scope">
                             <el-input v-model="scope.row.score" placeholder="请输入内容"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" prop="" label="课时数">
                        <template slot-scope="scope">
                             <el-input v-model="scope.row.periodcount" placeholder="请输入内容"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column width="100"  align="center" prop="" label="授课开始时间">
                        <template slot-scope="scope">
                             <el-date-picker
                              value-format="yyyy-MM-dd"
                                v-model="scope.row.begindate"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column width="100"  align="center" prop="" label="授课结束时间">
                        <template slot-scope="scope">
                             <el-date-picker
                              value-format="yyyy-MM-dd"
                                v-model="scope.row.enddate"
                                type="date"
                                placeholder="选择日期">
                            </el-date-picker>
                        </template>
                    </el-table-column>
                    <el-table-column :width="getTableHeaderWidthByOpButton1()"  align="center" prop="" label="操作">
                        <template slot-scope="scope">
                            <span v-if="form.classdetails.finishperiodcount===0 || !detailsParams.code" class="table-del pointer" @click="delCour(scope.row)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="btnBox">
                    <div class="addBtn" @click="handleAddClass">新增课程</div>
                </div>
                <template v-if="isShowFuInfo">
                    <div  class="moduleTitle mt-20">服务信息</div>
                    <div class="formItem" >
                        <div class="itemBox mr-30">
                            <el-form-item label="服务名称" prop="classdetails.servicename">
                                <el-input v-model="form.classdetails.servicename" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input>
                            </el-form-item>
                        </div>
                        <div class="itemBox">
                            <el-form-item label="服务电话" prop="classdetails.servicetel">
                                <el-input v-model="form.classdetails.servicetel" maxlength="20" show-word-limit placeholder="请输入" clearable></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <el-form-item label="服务二维码">
                        <div class="tips">建议尺寸 200*200px 或者 1:1，J PG、PNG 格式，图片小于 5M。</div>
                        <div class="uploadItemBox">
                            <div class="uploadItem">
                                <UploadFile v-if="visible" ref="uploadFile1" accept=".png,.jpeg,.jpg" :show-file-list="false" :scopeType="106" :fileMaxSize="5120" @success="severUploadSuccess">
                                    <div class="noCoveratturl" v-if="!severUrl.serviceqrcodeurl">
                                        <i class="el-icon-plus"></i>
                                        <div class="label">上传图片</div>
                                    </div>
                                    <img class="coveratturl" v-else :src="severUrl.serviceqrcodeurl + '?v=' + now" alt="">
                                </UploadFile>
                            </div>
                        </div>
                    </el-form-item>
                </template>
            </el-form>
        </el-scrollbar>
        <div slot="footer" style="text-align:right">
            <el-button @click="handleSave(1,'form')">保存为草稿</el-button>
            <el-button type="primary" :loading="isLoading" @click="handleSave(2,'form')">保存并发布</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {getCourseList,saveClass,getClassDetails,getCampusList,getCourseListBySelect} from '@/api/measApi/teachManagement.js'
import UploadFile from '@/components/measComponents/uploadFile/uploadFile.vue'
import UEditor from '@/components/measComponents/uEditor/uEditor.vue'
import SelectPage from '@/components/measComponents/selectPage/selectPage'
import {getTableDefaultPageSize} from '@/assets/measAssets/js/tools.js'
export default {
    data(){
        return {
            title: '新增',
            visible: false,
            isLoading: false,
            options: [
             
            ],
            rules:{
                'classdetails.name': [
                    { required: true, message: '请填写班级名称', trigger: 'blur' }
                ],
                'classdetails.campusname': [
                    { required: true, message: '请选择参与校区', trigger: 'blur' }
                ],
                'classdetails.uprice': [
                    { required: true, message: '请设置价格', trigger: 'blur' }
                ],
                'classdetails.begindate': [
                    { required: true, message: '请设置授课开始时间', trigger: 'blur' }
                ],
                'classdetails.enddate': [
                    { required: true, message: '请设置授课结束时间', trigger: 'blur' }
                ],
                'classdetails.enrollenddate': [
                    { required: true, message: '请设置授课结束时间', trigger: 'blur' }
                ],
                'classdetails.coveratturl': [
                    { required: true, message: '请设置授课结束时间', trigger: 'blur' }
                ]
            },
            detailsParams: {
                 code: "",
                 isonlyclassinfo: false
            },
            isShowFuInfo: true,//是否显示服务信息
            defaultForm: {},
            form: {
                classdetails: {
                    begindate: '',
                    enrollenddate: '',
                    campuscode: '',//参与校区code
                    campusname: '',//参与校区
                    code: '',//目标code
                    content: '',//班级详情
                    coverattid: '',//班级封面
                    coveratturl: '',//封面url，最多5个
                    datetime: '',
                    enddate: '',
                    finishperiodcount: '',//已上课
                    name: '',//班级名称
                    servicename: '',	//服务名称
                    serviceqrcodeid: '',	//服务二维码id
                    serviceqrcodeurl: '',	//服务二维码
                    servicetel: '',	//服务电话
                    status: '',	//结业状态：0草稿 10正常 11暂停 30已结业 100已删除
                    statusname: '',	
                    summary: '',	//班级简介
                    totalcoursecount: '',	//课程总数
                    totalperiodcount: '',	//排课数
                    totalscore: '',	//总学分数
                    totalstudentcount: '',	//学员数
                    uprice: '',	//授课价格（元）
                },
                courselist: [
                    
                ],
                savetype: '',//保存草稿
            },
            classInfo: {
                begindate: '',
                code: '',
                configcoursecode: '',
                configcoursename: '',
                enddate: '',
                name: '',
                periodcount: '',
                score: ''
            },
            coveratt1: {
                coverattid: '',
                coveratturl: ''
            },
            coveratt: [],
            coveratt2: {
                coverattid: '',
                coveratturl: ''
            },
            coveratt3: {
                coverattid: '',
                coveratturl: ''
            },
            coveratt4: {
                coverattid: '',
                coveratturl: ''
            },
            coveratt5: {
                coverattid: '',
                coveratturl: ''
            },
            uploadType: {
                catecode: '106',
                datatype: 'IMAGE',
                filekeyid: '',
                filesuffix: ''
            },
            now: new Date().getTime(),
            courParams: {
                condition: {
                    catecode: '',
                    catename: '',
                    classcode: '',
                    classname: '',
                    name: '',
                    status: ''
                },
                orderbyname: '',
                orderbyorder: '',
                page: 1,
                pagesize: 5
            },
            courNames: [],
            severUrl: {
                serviceqrcodeurl: '',
                serviceqrcodeid: ''
            },
            schoolList: [],
            schoolParams: {
                condition: {
                    name: '',
                },
            },
            schoolNames: [],
            paginationOption: {
                pagesize: 3,
                page: 1,
                total: 0
            },
            initData: [],
            results: [],
            initDataCourNames: [],
            paginationOptionCourNames: {
                pagesize: 5,
                page: 1,
                total: 0
            },
        }
        
    },
    components: {
        UploadFile,
        UEditor,
        SelectPage
    },
    methods: {
        init(title,code){
            this.title = title == 'new' ? '新增' : '编辑' 
            this.detailsParams.code = code
            this.paginationOption.page = 1
            this.paginationOptionCourNames.page = 1
            this.visible = true
            this.defaultForm = JSON.parse(JSON.stringify(this.form))
            this.getCampusList()
            this.getCourseListBySelect()
            if(code){
                this.getClassDetails()
            }
        },
        handleCourNames(row){
            return this.courNames.filter(item => {
                return item.name === row.name
            })
        },
        // 获取校区下拉
        getCampusList(){
            getCampusList(Object.assign(this.schoolParams, this.paginationOption)).then(res => {
                this.schoolList = res.data
                this.paginationOption.total = res.pageinfo.rowcount
            })
        },
        // querySearchAsync(queryString, cb){
        //     this.courParams.condition.name = queryString
        //     getCourseListBySelect(this.courParams).then(res => {
        //         this.courNames = res.data
        //         this.courNames.forEach(itm => {
        //             itm.value = itm.name
        //         })
        //         var results = queryString ? this.courNames.filter(this.createStateFilter(queryString)) : this.courNames;
        //         console.log(results,'results')
        //         this.results = results
        //         cb(results);
        //     })
        // },
        // createStateFilter(queryString) {
        //     return (state) => {
        //         console.log(state,'statestate')
        //         return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        //     };
        // },
        // 获取课程列表
        getCourseListBySelect(){
            getCourseListBySelect(this.courParams).then(res => {
                this.paginationOptionCourNames.total = res.pageinfo.rowcount
                res.data.forEach(itm => {
                    itm.value = itm.name
                })
                 this.courNames = res.data
            })
        },
        changePageGetListSchool(page){
            this.paginationOption.page = page
            this.getCampusList()
        },
        getSelectValueClass(value, index){
            this.form.courselist.some((item,num) => {
                if(item.name === value[0].name && index != num){
                    this.form.courselist[index].name = ''
                    this.form.courselist[index].code = ''
                    this.form.courselist[index].configcoursename = ''
                    this.form.courselist[index].configcoursecode = ''
                    this.form.courselist[index].value = ''
                    this.$message.error('不能选择相同的课程')
                    this.$refs.SelectPage.choiceValue = {}
                    return true 
                }else{
                    console.log('esle')
                    this.courNames.forEach((itm,idx) => {
                        if(itm.name === value[0].name ){
                            this.form.courselist[index].name = itm.name
                            this.form.courselist[index].configcoursename = itm.name
                            this.form.courselist[index].configcoursecode = itm.code
                        }
                    })
                }
            })
        },
        searchValue(value){
            this.courParams.condition.name = value
            this.courParams.page = 1
            this.getCourseListBySelect()
            console.log(value,'value')
        },
        changePageGetListClass(page){
            this.courParams.page = page
            this.getCourseListBySelect()
        },
        handleClose(){
            this.visible = false
            this.isLoading = false
            this.$refs.form.clearValidate()
            this.form.courselist = []
            this.detailsParams.code = ''
            this.form.classdetails.content = ''
            this.$refs.uEditor.init(this.form.classdetails.content)
            this.form = JSON.parse(JSON.stringify(this.defaultForm))
            console.log(this.form,'befor')
            this.coveratt = []
            this.coveratt1 = {
                coverattid: '',
                coveratturl: ''
            }
            this.coveratt2 = {
                coverattid: '',
                coveratturl: ''
            }
            this.coveratt3 = {
                coverattid: '',
                coveratturl: ''
            }
            this.coveratt4 = {
                coverattid: '',
                coveratturl: ''
            }
            this.coveratt5 = {
                coverattid: '',
                coveratturl: ''
            }
            this.severUrl = {
                serviceqrcodeurl: '',
                serviceqrcodeid: ''
            }
            this.courselist = []
            this.schoolNames = []
             this.initData = []
        },
        // 获取课程列表
        // getCourseList(){
        //     getCourseListBySelect(this.courParams).then(res => {
        //         console.log(res,'课程列表')
        //         this.courNames = res.data
        //     })
        // },
        // getCode(name){
        //     console.log(name,'name')
        //     this.form.classdetails.campusname = this.schoolNames.join(',')
        //     let code = []
        //     this.schoolList.map(item => {
        //         name.map(itm => {
        //             if(item.name === itm){
        //                 code.push(item.code)
        //                 return true
        //             }
        //         })
                
        //     })
        //     this.form.classdetails.campuscode = code.join(',')
        // },
        // 选择校区
        getSelectValue(value){
            let codeArr = []
            let nameArr = []
            value.forEach(item => {
                codeArr.push(item.code)
                nameArr.push(item.name)
            })
             this.form.classdetails.campusname = nameArr.join(',')
             this.form.classdetails.campuscode = codeArr.join(',')
            // console.log(value,'value')
        },
        // 获取班级详情
        getClassDetails(){
            getClassDetails(this.detailsParams).then(res => {
                console.log(res,'详情')
                // this.form = JSON.parse(JSON.stringify(res.data))
                let { classdetails, courselist} = res.data
                this.form.classdetails.begindate = classdetails.begindate
                this.form.classdetails.campuscode = classdetails.campuscode
                this.form.classdetails.campusname = classdetails.campusname
                // this.schoolNames = classdetails.campusname.split(',')
                classdetails.campuscode.split(',').forEach((item,index) => {
                    this.initData.push({
                        code: item,
                        name:  classdetails.campusname.split(',')[index]
                    })
                })
                this.form.classdetails.code = classdetails.code
                this.form.classdetails.content = classdetails.content
                this.$refs.uEditor.init(classdetails.content)
                this.form.classdetails.coverattid = classdetails.coverattid
                this.form.classdetails.coveratturl = classdetails.coveratturl
                this.form.classdetails.datetime = classdetails.datetime
                this.form.classdetails.enddate = classdetails.enddate
                this.form.classdetails.finishperiodcount = classdetails.finishperiodcount
                this.form.classdetails.name = classdetails.name
                this.form.classdetails.servicename = classdetails.servicename
                this.form.classdetails.serviceqrcodeid = classdetails.serviceqrcodeid
                this.form.classdetails.serviceqrcodeurl = classdetails.serviceqrcodeurl
                this.form.classdetails.servicetel = classdetails.servicetel
                this.form.classdetails.status = classdetails.status
                this.form.classdetails.statusname = classdetails.statusname
                this.form.classdetails.summary = classdetails.summary
                this.form.classdetails.totalcoursecount = classdetails.totalcoursecount
                this.form.classdetails.totalperiodcount = classdetails.totalperiodcount
                this.form.classdetails.totalscore = classdetails.totalscore
                this.form.classdetails.totalstudentcount = classdetails.totalstudentcount
                this.form.classdetails.uprice = classdetails.uprice
                this.form.classdetails.enrollenddate = classdetails.enrollenddate
                this.form.courselist = []
                // this.form.courselist = courselist
                courselist.forEach(item => {
                    this.form.courselist.push({
                        begindate: item.begindate,
                        code: item.code,
                        configcoursecode: item.configcoursecode,
                        enddate: item.enddate,
                        name: item.name,
                        configcoursename: item.name,
                        periodcount: item.periodcount,
                        score: item.score
                    })
                })
                this.initDataCourNames =  this.form.courselist
                // this.courNames = this.form.courselist
                console.log(this.initDataCourNames,'this.initDataCourNames')
                let coverArrCode = classdetails.coverattid.split(',')
                let coverArr = classdetails.coveratturl.split(',')
                // this.coveratt
                coverArrCode.forEach((item,index) => {
                    this.coveratt.push({
                        coverattid: item,
                        coveratturl: coverArr[index]
                    })
                })
                // console.log(this.form.courselist,'this.form.courselist')
                
                // coverArr.forEach((item,index) => {
                //     this['coveratt'+(index+1)].coveratturl = coverArr[index]
                // })
                // let coverArrCode = classdetails.coveratturl.split(',')
                // coverArrCode.forEach((item,index) => {
                //     this['coveratt'+(index+1)].coverattid = coverArrCode[index]
                // })
                this.severUrl.serviceqrcodeurl = classdetails.serviceqrcodeurl
                this.severUrl.serviceqrcodeid = classdetails.serviceqrcodeid
                if(!this.form.classdetails.servicename || !this.form.classdetails.servicetel || !this.form.classdetails.serviceqrcodeurl){
                    this.isShowFuInfo = false
                }
                console.log(this.form,'form')
            })
        },
        // 课程code
        getCourCode(row,index){
            console.log(name,index,'name,indexname,index')
            this.form.courselist.some((item,num) => {
                if(item.name === row.name && index != num){
                    this.form.courselist[index].name = ''
                    this.form.courselist[index].code = ''
                    this.form.courselist[index].configcoursename = ''
                    this.form.courselist[index].configcoursecode = ''
                    this.$message.error('不能选择相同的课程')
                    return true 
                }else{
                    this.courNames.forEach((itm,idx) => {
                        if(itm.name === row.name ){
                            this.form.courselist[index].name = itm.name
                            // this.form.courselist[index].code = itm.code
                            this.form.courselist[index].configcoursename = itm.name
                            this.form.courselist[index].configcoursecode = itm.code
                        }
                    })
                }
            })
        },
        // 新增课程
        handleAddClass(){
            console.log(this.form.courselist,'this.form.courselist')
            if(this.form.courselist.length === 0){
                this.form.courselist.push(JSON.parse(JSON.stringify(this.classInfo)))
            }else{
                let flag = true
                this.form.courselist.some(item => {
                    if(!item.name || !item.score || !item.begindate || !item.enddate || !item.periodcount){
                        flag = false
                        this.$message.error('请先完善课程，才能继续添加')
                        return true 
                    }
                })
                if(flag){
                    this.form.courselist.push(JSON.parse(JSON.stringify(this.classInfo)))
                }
            }
        },
        // 删除课程
        delCour(value){
           this.form.courselist = this.form.courselist.filter(item => {
                return item.name != value.name
           }) 
        },
        handleSave(num,formName){
            console.log(this.form,'form')
            this.setFormValue(formName)
            if(!this.form.classdetails.coveratturl){
                return this.$message.error('请设置图片封面')
            }
            if(num === 1){
                this.form.savetype = 0
               
            }else{
                this.form.savetype = 1
            }
            if(this.form.courselist.length> 0){
                let flag = true
                this.form.courselist.some(item => {
                    if(!item.name || !item.score || !item.begindate || !item.enddate || !item.periodcount){
                        
                        flag = false
                    }
                    return true
                })
                if(!flag){
                    return this.$message.error('请完善添加的课程信息')
                }
            }else{
                return  this.$message.error('请添加课程信息')
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isLoading = true
                    this.saveClass(formName)
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        saveClass(formName){
            try {
                saveClass(this.form).then(res => {
                    this.isLoading = false
                    if(res.code === '000'){
                        this.$refs[formName].resetFields();
                        this.$refs[formName].clearValidate()
                        this.visible = false
                        this.$message.success(res.msg)
                        this.$parent.init()
                        this.handleClose()
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            } catch (error) {
                this.$message.error('网络请求失败')
            }
        },
        getUEditorContent(content){
            this.form.classdetails.content = content
        },
        coveratt1UploadSuccess(file) {
            console.log(file,'file')
            let tmpoBJ = {
                coverattid: file.key,
                coveratturl: file.atturl
            }
            this.coveratt.push(JSON.parse(JSON.stringify(tmpoBJ)))
            console.log(this.coveratt,'this.coveratt')
            // this.coveratt1.coverattid = file.key
            // this.coveratt1.coveratturl = file.atturl
            this.now = new Date().getTime()
        },
        coveratt2UploadSuccess(file) {
            this.coveratt2.coverattid = file.key
            this.coveratt2.coveratturl = file.atturl
            this.now = new Date().getTime()
        },
        coveratt3UploadSuccess(file) {
            this.coveratt3.coverattid = file.key
            this.coveratt3.coveratturl = file.atturl
            this.now = new Date().getTime()
        },
        coveratt4UploadSuccess(file) {
            this.coveratt4.coverattid = file.key
            this.coveratt4.coveratturl = file.atturl
            this.now = new Date().getTime()
        },
        coveratt5UploadSuccess(file) {
            this.coveratt5.coverattid = file.key
            this.coveratt5.coveratturl = file.atturl
            this.now = new Date().getTime()
        },
        delImg(idx){
            this.coveratt = this.coveratt.filter((item,index) => {
                return idx!= index
            })
        },
        // form参数赋值
        setFormValue(){
            let coverattids = []
            let coveratturls = []
            // 课程封面
            // for(let i = 0; i < 5; i++) {
            //     if(this['coveratt' + (i + 1)].coverattid && this['coveratt' + (i + 1)].coveratturl)
            //     coverattids.push(this['coveratt' + (i + 1)].coverattid)
            //     coveratturls.push(this['coveratt' + (i + 1)].coveratturl)
            // }
            // coveratturls.some(item => {
            //     if (item) {
            //         this.form.classdetails.coverattid = coverattids.join(',')
            //         this.form.classdetails.coveratturl = coveratturls.join(',')
            //         return true
            //     }
            // })
            this.coveratt.forEach((item,index) => {
                coverattids.push(item.coverattid)
                coveratturls.push(item.coveratturl)
            })
            this.form.classdetails.coverattid = coverattids.join(',')
            this.form.classdetails.coveratturl = coveratturls.join(',')
            // 服务二维码
            this.form.classdetails.serviceqrcodeurl = this.severUrl.serviceqrcodeurl
            this.form.classdetails.serviceqrcodeid = this.severUrl.serviceqrcodeid
        },

        severUploadSuccess(){
            this.severUrl.serviceqrcodeid = file.key
            this.severUrl.serviceqrcodeurl = file.atturl
            this.now = new Date().getTime()
        }

    }
}
</script>
<style lang="scss" scoped>
.formItem{
    display: flex;
    width: 100%;
    margin-bottom: 15px;
    .itemBox{
        flex: 1;
    }
}
.table-del{
    color: #0B75FA;
}
.btnBox{
    padding: 20px;
    border: 1px solid #f1f1f1;
    border-top: none;
    .addBtn{
        width: 72px;
        height: 38px;
        background: #0B75FA;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        color: white;
        text-align: center;
        line-height: 38px;
    }
}
.el-form-item{
    .tips {
        font-size: 12px;
        color: #666666;
        line-height: 28px;
        position: absolute;
        left: 80px;
        top: -28px;
    }
    .uploadItemBox {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .uploadItem {
            margin-right: 10px;
            width: 80px;
            height: 80px;
            .imgItm{
                position: relative;
                .del{
                    background: rgba(0, 0, 0, 0.5);
                    position: absolute;
                     width: 80px;
                     display: none;
                    height: 80px;
                    left: 0;
                    top: 0;
                    cursor: pointer;
                    text-align: center;
                    line-height: 80px;
                    color: white;
                }
                &:hover{
                    .del{
                        display: block;
                    }
                }
            }
            .noCoveratturl {
                cursor: pointer;
                width: 80px;
                height: 80px;
                background: #D9D9D9;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .el-icon-plus {
                    font-size: 20px;
                    color: #fff;
                }
                .label {
                    font-size: 12px;
                    color: #666666;
                    line-height: 24px;
                }
            }
            .coveratturl {
                width: 80px;
                height: 80px;
                cursor: pointer;
            }
        }
    }
}
</style>